var isDevMode = process.env.NODE_ENV !== "production";
const host = window.location.host;
//let baseURL = isDevMode ? "https://ai-admin-v2.mrsys.xyz" : "";
//let baseURL = "https://admin.rosiechatai.com"
let mainURL = "https://admin.rosiechatai.com";
let baseURL = isDevMode ? "http://127.0.0.1:7878" : "";  //http://127.0.0.1:7878
let version = 1;
let isMain =
  host.indexOf("gp2.aichatsys.com") > -1 ||
  host.indexOf("admin.rosiechatai.com") > -1 ||
  isDevMode;
const CHECK_OPTIONS = [
  { label: "审核环境(A面)", value: 0 },
  { label: "正式环境(B面)", value: 1 },
];

const SEX_OPTIONS = [
  { label: "男性", value: 1 },
  { label: "女性", value: 2 },
  { label: "未知", value: 0 },
];
const STATUS_OPTIONS = [
  { label: "待审核", value: 0 },
  { label: "启用", value: 1 },
  { label: "禁用", value: -1 },
];


const NODE_OPTIONS = [
  { label: "GP2(美东节点)", value: "https://gp2.aichatsys.com" },
  { label: "GP3(美西节点)", value: "https://gp3.aichatsys.com" },
  { label: "GP4(美西节点)", value: "https://gp4.aichatsys.com" },
  { label: "GP5(美西节点)", value: "https://gp5.aichatsys.com" },
];


export default {
  baseURL,
  mainURL,
  version,
  SEX_OPTIONS,
  STATUS_OPTIONS,
  CHECK_OPTIONS,
  NODE_OPTIONS,
  isMain,
};



// WEBPACK FOOTER //
// ./src/utils/config.js